import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {NavLink} from 'react-router-dom';
import {connect} from "react-redux";
import {Container} from "react-bootstrap";
import {withTranslation} from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import {listenerRfid} from "../../index";
import configApp from "../../config/config";
import apiEmployee from "../../api/apiEmployee";
import {pageLoadManageActions as loader} from "../../reducers/load";
import { addBreamb, resetBreamb } from "../../reducers/breams-manage";
import SetRfidCard from "../screens/SetRfidCard";
import { notify } from "../blocks/Notify";
import Breams from "../blocks/Breams";
import MainNav from "../blocks/MainNav";
import Loader from "../blocks/Loader";
import { errorNotify } from "../../helpers/functions";

class SetRfidCardContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rfid: '',
            rfid_ready: false,
        };

        // Флаг, что компонент ещё смонтирован — чтобы не звать setState после unmount
        this._isMounted = true;

        document.title = props.t('Link RFID card');
        resetBreamb();
        addBreamb({title: props.t('Personal Area')});
        addBreamb({title: props.t('Link RFID card')});
    }

    componentWillUnmount() {
        this._isMounted = false;

        // Останавливаем прослушивание и снимаем HID-слушатель
        if (this.state.rfid_ready) {
            if (!configApp.device_settings.rfid.isHid) {
                listenerRfid.close().catch(() => {});
            } else {
                document.body.removeEventListener('keyup', this.handleKeyUp);
            }
        } else {
            // на всякий случай, если что-то осталось
            if (!configApp.device_settings.rfid.isHid) {
                listenerRfid.close().catch(() => {});
            }
            document.body.removeEventListener('keyup', this.handleKeyUp);
        }
    }

    handleResult = () => {
        const new_user_rfid = !configApp.device_settings.rfid.isHid
            ? this.state.rfid
            : this.state.rfid.slice(0, -5);

        loader.start('setRfid');

        apiEmployee.setRfidCard(this.props.user.data.uuid, new_user_rfid)
            .then(() => {
                this.props.history.push('/cabinet');
                notify(this.props.t('Card is linked'), 'success');
            })
            .catch((err) => {
                errorNotify(
                    this.props.t('Error linking card'),
                    err,
                    this.props.history.push,
                    this.props.user.isAuth
                );
            })
            .finally(() => loader.stop('setRfid'));
    };

    handleSetRfidResult = (res) => {
        if (!this._isMounted) return;
        if (this.state.rfid === res) return; // не перерисовываем зря
        this.setState({ rfid: res });
        console.log(res);
    };

    handleKeyUp = (e) => {
        if (!this._isMounted) return;
        this.setState((prev) => ({ rfid: prev.rfid + e.key }));
    };

    handleStartRfid = () => {
        // Уже слушаем — повторный запуск не нужен
        if (this.state.rfid_ready) return;

        console.log('handle start rfid');

        if (!configApp.device_settings.rfid.isHid) {
            listenerRfid.start()
                .then(
                    (res)=>{                    
                        console.log(res);
                        this.handleSetRfidResult(res);                       
                    }
                )
                .catch((err) => {
                    console.log(err);
                });
            this.setState({ rfid_ready: true });
        } else {
            document.body.addEventListener('keyup', this.handleKeyUp);
        }

        
    };

    handleStopRfid = () => {        
        // Уже остановлено — нечего делать
        if (!this.state.rfid_ready) return;

        console.log('handle stop');

        this.setState({
            rfid_ready: false,
            rfid: '',
        });

        if (!configApp.device_settings.rfid.isHid) {
            listenerRfid.close().catch(() => {});
        } else {
            document.body.removeEventListener('keyup', this.handleKeyUp);
        }
    };

    render() {
        if (window.__RENDER_COUNT === undefined) window.__RENDER_COUNT = 0;
            window.__RENDER_COUNT++;
            console.log('[SetRfidCardContainer] render #', window.__RENDER_COUNT, {
                rfid: this.state.rfid,
                rfid_ready: this.state.rfid_ready,
                isLoading: this.props.isLoading,
                user: this.props.user,
                app: this.props.app,
            });
        return (
            <>
                <Breams />
                <Loader
                    className="h-100"
                    isLoading={this.props.isLoading}
                    loadId={"setRfid"}
                    justifyContent="center"
                >
                    <SetRfidCard
                        {...this.state}
                        t={this.props.t}
                        handleStartRfid={this.handleStartRfid}
                        handleStopRfid={this.handleStopRfid}
                        handleResult={this.handleResult}
                    />
                </Loader>
                <MainNav className={`main-navi`}>
                    <Container className={`d-flex justify-content-between`}>
                        <NavLink to={"/cabinet"} className={`Btn Btn_success MuiButton`}>
                            <FontAwesomeIcon className="mr-4" icon={faArrowLeft}/>
                            <span>{this.props.t('Personal Area')}</span>
                        </NavLink>
                        <NavLink to={"/"} className={`Btn Btn_danger MuiButton`}>
                            <FontAwesomeIcon className="mr-4" icon={faSignOutAlt}/>
                            <span>{this.props.t('Exit')}</span>
                        </NavLink>
                    </Container>
                </MainNav>
            </>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        app: store.appState,
        isLoading: store.loadState.isLoading,
        user: store.userState,
    };
};

export default connect(mapStateToProps)(withRouter(withTranslation()(SetRfidCardContainer)));